import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const GalleryTitle = styled.h2`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.xlarge};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  margin: 0 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-size: ${barnesTheme.fontSizes.xlarge} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    margin: 0 0 ${barnesTheme.spacing.smallGap} 0 !important;
  }
`

export const TitleHairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GalleryGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: ${barnesTheme.spacing.contentGap};
  flex: 1;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
    flex: 1 !important;
  }
`

export const GalleryRow = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
  min-height: 0;

  @media print {
    display: flex !important;
    gap: 10px !important;
    flex: 1 !important;
    min-height: 0 !important;
  }
`

export const PhotoCell = styled.div<{ $flex?: number; $clickable?: boolean }>`
  flex: ${({ $flex }) => $flex || 1};
  background: ${barnesTheme.colors.grege};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  min-height: 0;

  @media print {
    flex: ${({ $flex }) => $flex || 1} !important;
    background: ${barnesTheme.colors.grege} !important;
    overflow: hidden !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    /* Empty slots (no <img>) print blank — no grège frame, no "Photo N"
       label — so missing photos just leave white space in the PDF. The
       grège placeholder is kept on screen as the click-to-add affordance. */
    &:not(:has(img)) {
      background: transparent !important;
    }
  }
`

export const PhotoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media print {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
`

export const PhotoPlaceholderText = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.textLight};

  /* Hidden in the PDF — empty photo slots stay blank instead of showing a
     "Photo N" label. Kept on screen as the editor's click-to-add hint. */
  @media print {
    display: none !important;
  }
`

/* Legacy exports for backwards compatibility */
export const ContentFlow = GalleryGrid
export const HeroPhoto = PhotoCell
export const PhotoGallery = GalleryRow
export const GalleryPhoto = PhotoCell
export const DescriptionTitle = GalleryTitle
export const DescriptionText = styled.div``
export const PullQuote = styled.blockquote``
export const TwoColumnLayout = GalleryGrid
export const LeftColumn = GalleryGrid
export const RightColumn = GalleryGrid
export const HighlightBox = styled.blockquote``
export const HighlightText = styled.span``
export const PhotoGrid = GalleryRow
export const SmallPhoto = PhotoCell
export const MediumPhoto = PhotoCell
export const TextSection = GalleryGrid
